"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipActionCode = void 0;
var MembershipActionCode;
(function (MembershipActionCode) {
    MembershipActionCode[MembershipActionCode["Proceed"] = 1] = "Proceed";
    MembershipActionCode[MembershipActionCode["Inform"] = 2] = "Inform";
    MembershipActionCode[MembershipActionCode["Block"] = 3] = "Block";
})(MembershipActionCode = exports.MembershipActionCode || (exports.MembershipActionCode = {}));
